// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { wishListSharingStatusStyles } from "@insite/content-library/Components/WishListSharingStatus";
import Information from "@mcmc/XDL/Icons/Information";
import Users from "@mcmc/XDL/Icons/Users";
import { css } from "styled-components";

// @override styles to use src icon from mcmc icons
wishListSharingStatusStyles.privateIcon = {
    src: Information,
    size: 15,
    css: css`
        margin-left: 5px;
    `,
};

wishListSharingStatusStyles.sharedIcon = {
    src: Users,
    size: 15,
    css: css`
        margin-right: 5px;
    `,
};

// @override styles to add the tooltip
wishListSharingStatusStyles.privateTooltip = {
    cssOverrides: {
        tooltipClickable: css`
            margin-left: 5px;
            display: inline;
        `,
    },
};

wishListSharingStatusStyles.statusText = {};
